import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, UserService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { CostProfileService } from '../cost-profile.service';
import { CostProfile } from '../cost-profile';
import { PropertyService } from '@app/_components/property';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-cost-profile',
    templateUrl: './cost-profile.component.html',
    styleUrls: ['./cost-profile.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class CostProfileComponent implements OnInit {
    properties: any;
    payWhenStatuses: any;
    payStatuses: any;
	users: string[];
    payToDetails: any;

	constructor(
		private userService: UserService,
		private propertyService: PropertyService,
		private primengConfig: PrimeNGConfig,
		private costProfileService: CostProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.costProfile = data?.costProfile,
			this.payWhenStatuses = costProfileService.payWhenStatuses,
			this.payStatuses = costProfileService.payStatuses;
			this.payToDetails = costProfileService.payToDetails;
			if(data.costProfile != undefined &&  data.costProfile != null){
				this.findUserById(data?.costProfile?.payToUserId);
			}
	}

	@Input() costProfile: CostProfile;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	costProfileId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	validationMessages = {
		'costProfileId': [],
		'shortTermRentalId': [{ type: 'required', message: 'Property is required' }],
		'propertyCode': [],
		'payTo': [{ type: 'required', message: 'Pay To is required' }],
		'payToUserId': [{ type: 'required', message: 'User is required' }],
		'payWhen': [],
		'payStatus': [],
		'title': [],
		'quantity': [],
		'costAmount': [],
		'costPercent': [],
		'opsNotes': [],
	};

	ngOnInit() {
		this.fetchProperties();
		this.fetchUsers();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole costProfile object
		if (this.costProfile) {
			this.costProfileId = this.costProfile.costProfileId;
			this.fixDates();
			this.form1.patchValue(this.costProfile);
		}
	}
	
	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.findAllSummary()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}
	
	fetchUsers() {
		if (!this.users || this.users === undefined || this.users.length < 1) {
			try {
				this.userService.findAll()
					.subscribe(
						res => {
							console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.users = res.data.users;
							return this.users;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.costProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.form1.value.payToUserId = this.form1.value.payToUserId.userId;
			this.formLoading = true;
			this.costProfileService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.costProfile = res.data.costProfile;
						this.doAdd.emit(this.costProfile);
					},
					(err: any) => {
						console.log('costProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('costProfile: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.form1.value.payToUserId = this.form1.value.payToUserId.userId;
			this.formLoading = true;

			this.costProfileService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.costProfile = res.data.costProfile;
						this.doUpdate.emit(this.costProfile);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.costProfileService.delete(this.costProfile.costProfileId)
				.subscribe(
					(res: any) => {
						console.log('costProfile-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.costProfile);
					},
					(err: any) => {
						console.log('costProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			costProfileId: [this.costProfileId],
			shortTermRentalId: ['', Validators.required],
			propertyCode: [],
			payTo: ['', Validators.required],
			payToUserId: ['', Validators.required],
			payWhen: [],
			payStatus: [],
			title: [],
			quantity: [],
			costAmount: [],
			costPercent: [],
			opsNotes: [],
			});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.costProfile.costProfileDate = moment(this.costProfile.costProfileDate).toDate();
	}
	
	/* On each keystroke search for the user */
	onKeyInput(event)
	{
		let query = event.query;
		this.findUsersWith(query);
		return this.users;
	}
	
	/* Search for user */
	findUsersWith(queryString: string)
	{
		this.userService.findUsersWith(queryString).pipe(first()).subscribe(

			data =>
			{
				console.log('taskUser serach: ' + JSON.stringify(data));
				this.users = [];
				this.users = data.data.userSummaryList;
				// console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}
	
	/* Search for user */
	findUserById(userId: any)
	{
		this.userService.findById(userId).pipe(first()).subscribe(

			data =>
			{
				console.log('taskUser serach: ' + JSON.stringify(data));
				this.form1.patchValue({
					payToUserId: data.data.user
				});
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}
}
